import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  inject,
  ElementRef,
  Renderer2
} from '@angular/core';
import { AuthenticationService } from "../../../pages/services/authentication.service";
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sophHasAccess]',
  standalone: true,
})
export class HasAccessDirective implements OnInit, OnDestroy {

  @Input('sophHasAccess')
  requiredPermissions: string[] = [];

  @Input()
  mustHaveAllPermissions: boolean = false;

  private el: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
  private renderer: Renderer2 = inject(Renderer2);
  private authService: AuthenticationService = inject(AuthenticationService);

  private permissionsLoadedSub: Subscription | null = null;

  ngOnInit(): void {
    this.permissionsLoadedSub = this.authService.permissionsLoaded.subscribe(loaded => {
      if (!loaded) {
        this.renderer.setStyle(this.el.nativeElement, 'display', '');
      } else {
        const allowed = this.authService.hasAccess(
          this.requiredPermissions,
          this.mustHaveAllPermissions
        );
        this.renderer.setStyle(this.el.nativeElement, 'display', allowed ? '' : 'none');
      }
    });
  }

  ngOnDestroy(): void {
    this.permissionsLoadedSub?.unsubscribe();
  }
}
